export enum CustomerSessionStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum CustomerSessionEvent {
  UPDATED = 'CUSTOMER_SESSION_UPDATED',
  CREATED = 'CUSTOMER_SESSION_CREATED',
}

export enum CustomerSessionErrorMessage {
  VENUE_ID_IS_REQUIRED = 'venueId is required',
  CUSTOMER_ID_IS_REQUIRED = 'customerId is required',
  SESSION_ID_IS_REQUIRED = 'sessionId is required',
}
